import { createSlice } from "@reduxjs/toolkit";
import { Storage } from "../../../../constants/storage";

const STAT_METHOD_KEY = Storage.nebula_stat_method;

const getInitialStatMethod = () => {
  const saved = localStorage.getItem(STAT_METHOD_KEY);
  return saved === "AVCO" || saved === "FIFO" ? saved : "FIFO";
};

const initialState = {
  statMethod: getInitialStatMethod(),
  expiryBannerDismissed: false,
  methodModalOpen: false,
  settingsPanelOpen: false,
  integrationModalOpen: false,
  statsData: null,
  holdingsData: null,
  backTestStatsData: null,
  backTestReturnsData: null,
  performance: {
    statsData: null,
    returnsData: null,
  },
};

const nebulaBrainSlice = createSlice({
  name: "nebulaBrain",
  initialState,
  reducers: {
    setStatMethod: (state, action) => {
      state.statMethod = action.payload;
      localStorage.setItem(STAT_METHOD_KEY, action.payload);
    },
    setMethodModalOpen: (state, action) => {
      state.methodModalOpen = action.payload;
    },
    setSettingsPanelOpen: (state, action) => {
      state.settingsPanelOpen = action.payload;
    },
    setIntegrationModalOpen: (state, action) => {
      state.integrationModalOpen = action.payload;
    },
    setDashboardHoldings: (state, action) => {
      state.holdingsData = action.payload;
    },
    setDashboardStats: (state, action) => {
      state.statsData = action.payload;
    },
    setDashboardBackTestStats: (state, action) => {
      state.backTestStatsData = action.payload;
    },
    setDashboardBackTestReturns: (state, action) => {
      state.backTestReturnsData = action.payload;
    },
    setPerformanceStats: (state, action) => {
      state.performance.statsData = action.payload;
    },
    setPerformanceReturns: (state, action) => {
      state.performance.returnsData = action.payload;
    },
    dismissExpiryBanner: (state) => {
      state.expiryBannerDismissed = true;
    },
  },
});

export const {
  setStatMethod,
  setMethodModalOpen,
  setSettingsPanelOpen,
  setIntegrationModalOpen,
  setDashboardHoldings,
  setDashboardStats,
  setDashboardBackTestStats,
  setDashboardBackTestReturns,
  setPerformanceStats,
  setPerformanceReturns,
  dismissExpiryBanner,
} = nebulaBrainSlice.actions;

export default nebulaBrainSlice.reducer;
